import { AdditionalData } from '../PageView';

import { ActionBlockSlice, ActionBlockSliceProps } from './Slices/ActionBlockSlice';
import {
    AgencyHighlightBlockSlice,
    AgencyHighlightBlockSliceProps,
} from './Slices/AgencyHighlightBlockSlice';
import { CarouselBlockSlice, CarouselBlockSliceProps } from './Slices/CarouselBlockSlice';
import {
    ComboImageAndTextBlockSlice,
    ComboImageAndTextBlockSliceProps,
} from './Slices/ComboImageAndTextBlockSlice';
import { EditoBlockSlice, EditoBlockSliceProps } from './Slices/EditoBlockSlice';
import { HeaderBlockSlice, HeaderBlockSliceProps } from './Slices/HeaderBlockSlice';
import {
    HeaderBlockWithPictureSlice,
    HeaderBlockWithPictureSliceProps,
} from './Slices/HeaderBlockWithPictureSlice';
import {
    HighlightPostBlockSlice,
    HighlightPostBlockSliceProps,
} from './Slices/HighlightPostBlockSlice';
import {
    HighlightTextBlockSlice,
    HighlightTextBlockSliceProps,
} from './Slices/HighlightTextBlockSlice';
import {
    OneImageAndTextBlockSlice,
    OneImageAndTextBlockSliceProps,
} from './Slices/OneImageAndTextBlockSlice';
import {
    PostBlockWithDestinationOrItinerarySlice,
    PostBlockWithDestinationOrItinerarySliceProps,
} from './Slices/PostBlockWithDestinationOrItinerarySlice';
import { SoloPostBlockSlice, SoloPostBlockSliceProps } from './Slices/SoloPostBlockSlice';
import { TextBlockSlice, TextBlockSliceProps } from './Slices/TextBlockSlice';
import { TitlePostBlockSlice, TitlePostBlockSliceProps } from './Slices/TitlePostBlockSlice';
import {
    TwoImagesAndTextBlockSlice,
    TwoImagesAndTextBlockSliceProps,
} from './Slices/TwoImagesAndTextBlockSlice';

type Props = {
    slice:
        | HeaderBlockWithPictureSliceProps
        | HeaderBlockSliceProps
        | ComboImageAndTextBlockSliceProps
        | TextBlockSliceProps
        | CarouselBlockSliceProps
        | OneImageAndTextBlockSliceProps
        | TwoImagesAndTextBlockSliceProps
        | SoloPostBlockSliceProps
        | TitlePostBlockSliceProps
        | PostBlockWithDestinationOrItinerarySliceProps
        | AgencyHighlightBlockSliceProps
        | ActionBlockSliceProps
        | HighlightTextBlockSliceProps
        | EditoBlockSliceProps
        | HighlightPostBlockSliceProps;

    sliceIndex?: number;
    gridSliceIndex?: number;
    additionalData: AdditionalData;
};

export function SliceView({ slice, additionalData, sliceIndex, gridSliceIndex }: Props) {
    switch (slice.type) {
        case 'header_block_with_picture':
            return <HeaderBlockWithPictureSlice {...slice} />;
        case 'header_block':
            return <HeaderBlockSlice {...slice} />;
        case 'combo_image_and_text_block':
            return <ComboImageAndTextBlockSlice {...slice} sliceIndex={sliceIndex} />;
        case 'text_block':
            return <TextBlockSlice {...slice} />;
        case 'carousel_block':
            return <CarouselBlockSlice {...slice} sliceIndex={sliceIndex} />;
        case '1_image_and_text_block':
            return <OneImageAndTextBlockSlice {...slice} sliceIndex={sliceIndex} />;
        case '2_images_and_text_block':
            return <TwoImagesAndTextBlockSlice {...slice} sliceIndex={sliceIndex} />;
        case 'solo_post_block':
            return <SoloPostBlockSlice {...slice} sliceIndex={sliceIndex} />;
        case 'title_post_block':
            return <TitlePostBlockSlice {...slice} />;
        case 'post_block_with_destination':
            return (
                <PostBlockWithDestinationOrItinerarySlice
                    {...slice}
                    data={additionalData}
                    gridSliceIndex={gridSliceIndex}
                    sliceIndex={sliceIndex}
                />
            );
        case 'post_block_with_itinerary':
            return (
                <PostBlockWithDestinationOrItinerarySlice
                    {...slice}
                    data={additionalData}
                    gridSliceIndex={gridSliceIndex}
                    sliceIndex={sliceIndex}
                />
            );
        case 'agency_highlight_block':
            return <AgencyHighlightBlockSlice {...slice} agenciesData={additionalData.agencies} />;
        case 'action_block':
            return <ActionBlockSlice {...slice} sliceIndex={sliceIndex} />;
        case 'highlight_text_block':
            return <HighlightTextBlockSlice {...slice} sliceIndex={sliceIndex} />;
        case 'edito_block':
            return <EditoBlockSlice {...slice} />;
        case 'highlight_post_block':
            return <HighlightPostBlockSlice {...slice} />;
    }
}
